// Días de descanso obligatorio - Ley Federal del Trabajo, art. 74.
// En estos días no se calculan faltas ni asistencias.

const pad = (n) => String(n).padStart(2, "0");
const fmt = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;

// n-ésimo lunes (1-based) de un mes (m: 1-12)
const nEsimoLunes = (year, m, n) => {
    const primerDia = new Date(year, m - 1, 1).getDay(); // 0=dom ... 1=lun
    const primerLunes = 1 + ((8 - primerDia) % 7);
    return primerLunes + (n - 1) * 7;
};

const cache = {};

export const getDiasFestivosLFT = (year) => {
    if (cache[year]) return cache[year];
    const dias = {
        [fmt(year, 1, 1)]: "Año Nuevo",
        [fmt(year, 2, nEsimoLunes(year, 2, 1))]: "Día de la Constitución",
        [fmt(year, 3, nEsimoLunes(year, 3, 3))]: "Natalicio de Benito Juárez",
        [fmt(year, 5, 1)]: "Día del Trabajo",
        [fmt(year, 9, 16)]: "Independencia de México",
        [fmt(year, 11, nEsimoLunes(year, 11, 3))]: "Día de la Revolución",
        [fmt(year, 12, 25)]: "Navidad",
    };
    // Transmisión del Poder Ejecutivo Federal, cada 6 años (2024, 2030, ...)
    if ((year - 2024) % 6 === 0) {
        dias[fmt(year, 10, 1)] = "Transmisión del Poder Ejecutivo";
    }
    cache[year] = dias;
    return dias;
};

// dateStr: "YYYY-MM-DD"
export const nombreDiaFestivo = (dateStr) => {
    if (!dateStr) return null;
    const year = Number(dateStr.slice(0, 4));
    return getDiasFestivosLFT(year)[dateStr] || null;
};

export const esDiaFestivo = (dateStr) => !!nombreDiaFestivo(dateStr);
